// extracted by mini-css-extract-plugin
module.exports = {"artikkelDato":"ArtikkelDato_artikkelDato__2jYdd","small":"ArtikkelDato_small__xuw_D"};